/* eslint-disable */
import React from 'react'
import HeroBannerStyle from './index.style'
import BreadCrumb from '../breadcrumb'
import { Grid, Row, Col } from 'react-flexbox-grid'

const HeroBanner = props => {
  const {
    breadCrumb,
    picture,
    title,
    paragraph,
    subTitleHeroBanner,
    tag
  } = props
  return (
    <HeroBannerStyle>
      <Grid className="container-hero-banner border-box-box-sizing">
        <img
          className="hero-banner--background"
          src={picture.background}
          alt="halojasa/background"
        />
        <img className="hero-banner--people" src={picture.image} alt="halojasa/service-banner" />
        <img
          className="hero-banner-background-mobile"
          src={picture.mobile}
          alt="halojasa/service-icon"
        />
        <div className="hero-banner border-box-box-sizing">
          <Row>
            <Col xs={5} md={5} lg={6} className="hero-banner-content">
              <BreadCrumb options={breadCrumb}></BreadCrumb>
              {title}
              <div className="hero-sub">{subTitleHeroBanner}</div>
              <div className="hero-tag">{tag}</div>
              {paragraph}
            </Col>
          </Row>
        </div>
      </Grid>
    </HeroBannerStyle>
  )
}

export default HeroBanner
